import { Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import { Funnel, Search } from "react-bootstrap-icons";

function WithdrawalFilters({
    filterStatus,
    searchQuery,
    setSearchQuery,
    handleFilterChange,
    handleSearch,
    resetFilters
}) {
    return (
        <Form onSubmit={handleSearch}>
            <Row className="g-3">
                <Col lg={4} md={6}>
                    <Form.Group>
                        <Form.Label><Funnel className="mr-2" /> Filter by Status</Form.Label>
                        <Form.Control
                            as="select"
                            value={filterStatus}
                            onChange={(e) => handleFilterChange(e.target.value)}
                        >
                            <option value="all">All Requests</option>
                            <option value="pending">Pending</option>
                            <option value="approved">Approved</option>
                            <option value="rejected">Rejected</option>
                            <option value="processed">Processed</option>
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col lg={6} md={6}>
                    <Form.Group>
                        <Form.Label><Search className="mr-2" /> Search by Member ID</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type="text"
                                placeholder="Enter Member ID"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <InputGroup.Append>
                                <Button variant="primary" type="submit">
                                    Search
                                </Button>
                            </InputGroup.Append>
                        </InputGroup>
                    </Form.Group>
                </Col>
                <Col lg={2} className="d-flex align-items-end">
                    <Button
                        variant="outline-secondary"
                        className="w-100"
                        onClick={resetFilters}
                    >
                        Reset Filters
                    </Button>
                </Col>
            </Row>
        </Form>
    );
}
export default WithdrawalFilters;